/* IMPORTANT!!!! for other languages change countryCode and api-urls (/src/views) */
import { createI18n } from 'vue-i18n'
import nl from './nl.json'

const i18n = createI18n({
    locale: 'nl',
    fallbackLocale: 'nl',
    globalInjection: true,
    legacy: false,
    messages: {
        nl
    },
    escapeParameterHtml: false,
    messageResolver: null
})

export default i18n